import React from "react";
import { Hand } from "lucide-react";

/**
 * Matches {@link PlayerAvatarWithScore} column height (circle + score-badge inset)
 * for pick rows when there is no headshot (e.g. missed cut).
 */
export function PickRowAvatarPlaceholder() {
    return (
        <div className="relative inline-flex shrink-0">
            <div
                className="flex h-10 w-10 items-center justify-center rounded-full border border-masters-moss/40 bg-masters-moss"
                aria-hidden
            >
                <Hand
                    className="h-[18px] w-[18px] origin-[70%_90%] text-masters-gold motion-reduce:animate-none motion-safe:animate-pick-hand-wave"
                    strokeWidth={1.75}
                    aria-hidden
                />
            </div>
            <span
                className="pointer-events-none absolute bottom-0 right-0 z-[1] min-w-[1.1rem] translate-x-0.5 translate-y-0.5 select-none rounded-sm border border-transparent px-[3px] py-px text-[9px] font-bold leading-none opacity-0"
                aria-hidden
            >
                E
            </span>
        </div>
    );
}

/** Reserve vertical space similar to a typical `PickRoundMeta` block on pick cards. */
export const MISSED_CUT_META_RESERVE_CLASS = "min-h-[1.5rem]";

/** Minimum row height so missed-cut cards align with common made-cut pick rows. */
export const MISSED_CUT_CARD_MIN_HEIGHT_CLASS = "min-h-[6.5rem]";
